import { Box, FormControl, FormLabel, List, ListItem } from "@mui/material";
import { CustomTextField } from "../../../components/TextFields";
import { styled } from "@mui/styles";
const Label = styled(FormLabel)({
  width: "100%",
  "&.MuiFormLabel-root": {
    textAlign: "right",
    color: "divider",
    fontSize: "1.2rem",
    fontFamily: "'YekanBold !important'",
  },
  "& .MuiFormLabel-asterisk": { color: "red" },
});
export default function AnsawersTable({
  error,
  helperText,
  defaultValue,
  onChange,
}: {
  error?: boolean;
  helperText?: string;
  defaultValue?: string[];
  onChange: (value: string, indx: number) => void;
}) {
  return (
    <FormControl fullWidth>
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Label
          sx={{
            background: "#808080",
            color: "#333",
            borderRadius: ".5rem",
            padding: "1rem .5rem",
          }}
          required
        >
          لیست جواب ها
        </Label>
        <List sx={{ width: "100%" }}>
          {[1, 2, 3, 4].map((item: any, index: number) => (
            <ListItem key={item.id} sx={{ gap: ".5rem" }}>
              <CustomTextField
                label={`گزینه ${index + 1}`}
                required
                variant="outlined"
                error={error}
                helperText={helperText}
                defaultValue={
                  defaultValue?.length === 4 ? defaultValue[index] : undefined
                }
                onChange={(e) => onChange(e.target.value, index)}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </FormControl>
  );
}
